import { render, staticRenderFns } from "./SiteSelectorAndAccountButton.vue?vue&type=template&id=20807022"
import script from "./SiteSelectorAndAccountButton.vue?vue&type=script&lang=js"
export * from "./SiteSelectorAndAccountButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports